import { render, staticRenderFns } from "./ListRomaneio.vue?vue&type=template&id=4c2a8d54&scoped=true"
import script from "./ListRomaneio.vue?vue&type=script&lang=js"
export * from "./ListRomaneio.vue?vue&type=script&lang=js"
import style0 from "./ListRomaneio.vue?vue&type=style&index=0&id=4c2a8d54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a8d54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2a8d54')) {
      api.createRecord('4c2a8d54', component.options)
    } else {
      api.reload('4c2a8d54', component.options)
    }
    module.hot.accept("./ListRomaneio.vue?vue&type=template&id=4c2a8d54&scoped=true", function () {
      api.rerender('4c2a8d54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/customReports/components/tables/ListRomaneio.vue"
export default component.exports